/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-curly-newline */
import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router';
import Cookies from 'js-cookie';
import { useMediaQuery } from 'react-responsive';
import moment from 'moment';
import MotionState from '../motionState/MotionState';
import TruckAssetIcon from './img/truckAssets.svg';
import TimeIcon from './img/time.svg';
import AddressIcon from './img/address.svg';
import GPSFixIcon from './img/gpsfix.svg';
import NolocationServiceIcon from './img/noLocationService.svg';
import WifiIcon from './img/wifi.svg';
import BeaconIcon from './img/beaconConnection.svg';
import SpeedometerIcon from './img/speedometer.svg';
import PointerIcon from './img/pointer.svg';
import BatteryIcon from './img/battery.svg';
import SignalIcon from './img/signal.svg';
import OverspeedIcon from './img/overspeed.svg';
import InactiveIcon from './img/inactive.svg';
import AssetUtiliseIcon from './img/assetUtilise.svg';
import OrangeClockRewind from './img/clockRewind.svg';
import HighSignalIcon from './img/highSignal.svg';
import MediumSignalIcon from './img/mediumSignal.svg';
import LowSignalIcon from './img/lowSignal.svg';
import NoTelemetryIcon from './img/featureIcon.svg';
import CloseButtonIcon from './img/closeButton.svg';
import OverChargeIcon from './img/overcharge.svg';
import GasStationIcon from './img/gas-station.svg';
import MileageIcon from './img/mileage.svg';
import FuelStateBadge from './FuelStateBadge';
import { fetchFuelPolicyForVehiclePreset } from './fetchDeviceFuelPolicy';
import EvCharge from './img/ev-charge.svg';
import EvTemp from './img/ev-temp.svg';
import EvDistance from './img/ev-distance.svg';
import {
    LatestDataButton, AssetCardButton,
} from '../buttonComponent/ButtonComponent';
import ToolTips from '../tooltip/ToolTips';
import { APISendTeltonikaCommand, APIGetDevices } from '../../config/restAPI/FetchAPI';
import './assetDetailsCard.css';
import ExcellentIcon from './img/excellent.svg';
import PoorIcon from './img/poor.svg';
import GoodIcon from './img/good.svg';
import DegradedIcon from './img/degraded.svg';
import EvIndicator from './EvIndicator';
import EvIcon from './EvIcon';
import { getFuelLevelTelemetry, getTelemetrySourceData } from './telemetrySourceData';
import { computeFuelMappingBreakdown } from './getFuelState';
import ScanSummaryCard from '../scanSummaryCard/ScanSummaryCard';
import {
    mapDeviceToConfigurationState,
    resolveDeviceOid,
} from './mapDeviceToConfigurationState';

export const getBatteryState = (dcVolt, batteryMappingPreference) => {
    if (!batteryMappingPreference || dcVolt == null) {
        return {
            state: null,
            icon: null,
            percentage: null,
        };
    }
    let batteryPercentage = null;
    const { tableMap, equationMap } = batteryMappingPreference;
    if (tableMap && tableMap.enabled && tableMap.mapping) {
        const rangeMapping = tableMap.mapping.find((range) => dcVolt <= range.voltageFrom && dcVolt >= range.voltageTo);
        if (rangeMapping) {
            batteryPercentage = rangeMapping.percentage;
        }
    } else if (equationMap && equationMap.enabled && equationMap.mapping) {
        const { a2, a1, a0 } = equationMap.mapping;
        batteryPercentage = a2 * (dcVolt ** 2) + a1 * dcVolt + a0;
        batteryPercentage = Math.max(0, Math.min(100, batteryPercentage));
    }
    if (batteryPercentage == null) {
            return {
                state: null,
                icon: null,
                percentage: null,
            };
    }
    const { percentageMapping } = batteryMappingPreference;
    let batteryState = null;
    let batteryIcon = null;

    if (percentageMapping) {
        const rangeMapping = percentageMapping.find((range) => batteryPercentage <= range.percentageFrom && batteryPercentage >= range.percentageTo);

        if (rangeMapping) {
            batteryState = rangeMapping.state;
            switch (rangeMapping.state.toLowerCase()) {
                case 'excellent':
                    batteryIcon = ExcellentIcon;
                    break;
                case 'good':
                    batteryIcon = GoodIcon;
                    break;
                case 'poor':
                    batteryIcon = PoorIcon;
                    break;
                case 'replacement / charging required':
                    batteryIcon = DegradedIcon;
                    break;
                default:
                    break;
            }
        }
    }
    return {
        state: batteryState,
        icon: batteryIcon,
        percentage: batteryPercentage,
    };
};

export const getEvBatteryState = (batteryPercentage, batteryConfigId) => {
    // Check for both parameters
    if (batteryPercentage == null || !batteryConfigId) {
        return {
            state: null,
            icon: null,
            percentage: null,
        };
    }

    const { percentageMapping } = batteryConfigId;
    let batteryState = null;
    let batteryIcon = null;

    if (percentageMapping) {
        const rangeMapping = percentageMapping.find((range) => batteryPercentage <= range.percentageFrom && batteryPercentage >= range.percentageTo);

        if (rangeMapping) {
            batteryState = rangeMapping.state;
            // Use a switch statement to map state to icon
            switch (rangeMapping.state.toLowerCase()) {
                case 'excellent':
                    batteryIcon = ExcellentIcon;
                    break;
                case 'good':
                    batteryIcon = GoodIcon;
                    break;
                case 'poor':
                    batteryIcon = PoorIcon;
                    break;
                case 'replacement / charging required':
                    batteryIcon = DegradedIcon;
                    break;
                default:
                    break;
            }
        }
    }

    return {
        state: batteryState,
        icon: batteryIcon,
        percentage: batteryPercentage,
    };
};

export const signalIcon = (signal) => {
    if (signal) {
        if (signal > 80) {
            return <img loading="lazy" src={HighSignalIcon} alt="lqiEx" style={{ display: 'flex', alignItems: 'center' }} />;
        } if (signal <= 79 && signal > 40) {
            return <img loading="lazy" src={MediumSignalIcon} alt="lqiG" />;
        }
        return <img loading="lazy" src={LowSignalIcon} alt="lqiP" />;
    }
    return null;
};

// logic for signal text
export const signalText = (signal) => {
    if (signal) {
        if (signal > 80) {
            return 'Good Signal Quality';
        } if (signal <= 79 && signal > 40) {
            return 'Average Signal Quality';
        }
        return 'Poor Signal Quality';
    }
    return null;
};

export default function AssetCardMore(props) {
    const {
        markerValue, timeStampDisplay, closeButton, getLatestDataButton, lastSeenTimestamp, assetSelection,
    } = props;
    const navigate = useNavigate();
    const [hover, setHover] = useState(false);
    const [loading, setLoading] = useState(false);
    const [displayLastSeen, setDisplayLastSeen] = useState(false);
    const [apiLoading, setApiLoading] = useState(false);
    const [immobilized, setImmobilized] = useState(false);
    const textElementRef = useRef();
    const token = Cookies.get('jwtToken');
    const agencyId = Cookies.get('agencyUUID');
    const [hovered, setHovered] = useState(false);

    const isDefault = useMediaQuery({
        query: '(min-width: 1024px)',
    });
    const isMobileOrTablet = useMediaQuery({
        query: '(max-width: 1023px)',
    });

    const compareSize = () => {
        if (textElementRef && textElementRef.current && textElementRef.current.scrollWidth && textElementRef?.current?.clientWidth) {
            const compare = textElementRef.current.scrollWidth > textElementRef.current.clientWidth;
            // console.log('compare: ', compare);
            setHover(compare);
        }
    };

    const fetchDevice = async (value) => {
        const deviceOid = resolveDeviceOid(value);
        if (!deviceOid) {
            return;
        }

        const params = {
            oid: deviceOid,
            pageNumber: 1,
        };
        try {
            const result = await APIGetDevices(setLoading, token, agencyId, params);
            const data = result?.data?.data;
            if (result?.data?.status === 200 && Array.isArray(data) && data.length > 0) {
                const assetDetails = mapDeviceToConfigurationState(data[0]);
                if (assetDetails) {
                    navigate('/inventory/assetdevices/configuration', { replace: true, state: assetDetails });
                    setLoading(false);
                }
            }
        } catch (err) {
            // console.log('fetch error', err);
        }
    };

    const [devicePreferences, setDevicePreferences] = useState(null);

    // Function to fetch fuel and mileage source for device
    const fetchFuelAndMileageSource = async (value) => {
        const params = {
            oid: value.deviceOid,
            pageNumber: 1,
        };
        try {
            const result = await APIGetDevices(setLoading, token, agencyId, params);
            if (result.data.status === 200) {
                const { data } = result.data;
                if (data.length > 0) {
                    const [{
                        oid, assetName, deviceSerial, fuelSource, mileageSource, fuelCapacity, fuelMappingPreference, batteryMappingPreference, starterBatteryConfigId, batteryOneConfigId, batteryTwoConfigId, vehiclePreset,
                    }] = data;
                    const fuelPolicy = await fetchFuelPolicyForVehiclePreset(token, agencyId, vehiclePreset);
                    const assetDetails = {
                        id: oid,
                        deviceSN: deviceSerial,
                        assetName: assetName || null,
                        fuelSource: fuelSource,
                        mileageSource: mileageSource,
                        fuelCapacity: fuelCapacity,
                        fuelMappingPreference: fuelMappingPreference || null,
                        fuelPolicy: fuelPolicy || null,
                        vehiclePreset: vehiclePreset || null,
                        batteryMappingPreference: batteryMappingPreference,
                        starterBatteryConfigId: starterBatteryConfigId,
                        batteryOneConfigId: batteryOneConfigId,
                        batteryTwoConfigId: batteryTwoConfigId,
                    };
                    setDevicePreferences(assetDetails);
                }
            }
        } catch (err) {
            // console.log('fetch error', err);
        }
    };

    useEffect(() => {
        if (markerValue && markerValue.deviceOid) {
            fetchFuelAndMileageSource(markerValue);
        }
    }, [markerValue]);

    const {
        fuelLevelPerc,
        fuelLevelLitre,
        fuelLevelVoltage,
    } = getFuelLevelTelemetry(markerValue, devicePreferences?.fuelSource);
    const fuelPolicyForDisplay = devicePreferences?.fuelPolicy || devicePreferences?.fuelMappingPreference;
    const {
        percentage: computedFuelLevelPerc,
        litres: computedFuelLevelLitre,
        levelSourceState: fuelLevelSourceState,
    } = computeFuelMappingBreakdown(
        fuelLevelPerc,
        fuelLevelLitre,
        fuelPolicyForDisplay,
        devicePreferences?.fuelCapacity,
        devicePreferences?.vehiclePreset,
        fuelLevelVoltage,
    );
    const fuelStateBadge = fuelLevelSourceState || null;

    // Retrieving Mileage Source
    const mileage = getTelemetrySourceData(markerValue, devicePreferences?.mileageSource, 'mileageKm');
    const batteryTemp = getTelemetrySourceData(markerValue, devicePreferences?.mileageSource, 'oemBatteryTemperature');
    const rangeRemain = getTelemetrySourceData(markerValue, devicePreferences?.mileageSource, 'oemRemainingDistance');
    const batteryLevel = getTelemetrySourceData(markerValue, devicePreferences?.mileageSource, 'oemBatteryChargeLevel');

    // compare once and add resize listener on "componentDidMount" (this for elipsis event listener)
    useEffect(() => {
        compareSize();
        window.addEventListener('resize', compareSize);
    }, []);

    // remove resize listener again on "componentWillUnmount" (this for elipsis event listener)
    useEffect(() => () => {
        window.removeEventListener('resize', compareSize);
    }, []);

    const geoLocationStatus = (geolocation) => {
        switch (geolocation) {
            case 0:
                return 'GPS';
            case 16:
                return 'Wifi';
            case 17:
                return 'NoWifi';
            default:
                return 'Garbage';
        }
    };

    const checkHistoryLocationStatus = () => {
        if (markerValue.beacon) {
            if (geoLocationStatus(markerValue.geolocationStatus) === 'NoWifi' || geoLocationStatus(markerValue.geolocationStatus) === 'Garbage') {
                setDisplayLastSeen(false);
            }
        } else if (markerValue.geolocationStatus) {
            // this to check if status is GPS
            if ((geoLocationStatus(markerValue.geolocationStatus) === 'GPS') || (geoLocationStatus(markerValue.geolocationStatus) === 'Wifi')) {
                setDisplayLastSeen(false); // not display the history location

                // to check if the status noWifi or garbage
            } else if ((geoLocationStatus(markerValue.geolocationStatus) === 'NoWifi') || (geoLocationStatus(markerValue.geolocationStatus) === 'Garbage')) {
                // if lastSeenTimestamp, lat and lon have value
                if (markerValue.lastSeenTimestamp && markerValue.latitude && markerValue.longitude) {
                    setDisplayLastSeen(true); // display the history location
                } else {
                    setDisplayLastSeen(false); // not display the history location
                }
            } else {
                setDisplayLastSeen(false); // not display the history location
            }
        } else {
            setDisplayLastSeen(false); // not display the history location
        }
    };

    useEffect(() => {
        if (Object.keys(markerValue || {}).length > 0) {
            checkHistoryLocationStatus();
        }
    }, [markerValue]);

    // logic for geolocationStatus img
    const geolocationStatusImg = (status, beacon) => {
        if (beacon) {
            return <img loading="lazy" src={BeaconIcon} alt="beacon-icon" />;
        }
        switch (status) {
            case 0:
                return <img loading="lazy" src={GPSFixIcon} alt="gps-fix" />;
            case 16:
                return <img loading="lazy" src={WifiIcon} alt="no-location" />;
            case 17:
                return <img loading="lazy" src={NolocationServiceIcon} alt="NolocationServiceIcon" />;
            default:
                return <img loading="lazy" src={NolocationServiceIcon} alt="NolocationServiceIcon" />;
        }
    };

    // logic for geolocationStatus text
    const geoLocationStatusText = (status, beacon) => {
        if (beacon) {
            return 'Indoor Beacon';
        }
        switch (status) {
            case 0:
                return 'GPS Fix';
            case 16:
                return 'Wi-Fi Geolocation';
            case 17:
                return 'No Location Service';
            default:
                return 'No Location Service';
        }
    };

    // logic for geolocationDetailText
    const geoLocationDetailText = (status, nsat, geoAccuracy, beacon) => {
        if (beacon) {
            return { text: `${beacon.locationName}`, description: '' };
        }
        switch (status) {
            case 0:
                if (nsat <= 4) {
                    return { text: 'Bad', description: 'Some drifts and inaccuracies expected' };
                }
                if (nsat >= 5 && nsat <= 8) {
                    return { text: 'Good', description: '<2.5m CEP accuracy, minimal drift' };
                }
                if (nsat >= 9) {
                    return { text: 'Excellent', description: '<2.5m CEP accuracy' };
                }
                return { text: `${nsat} Satellites`, description: '' };
            case 16:
                return { text: `Accurate to ${geoAccuracy} Meters`, description: '' };
            default:
                return { text: '', description: '' };
        }
    };

    const { text, description } = geoLocationDetailText(markerValue.geolocationStatus, markerValue.nSat, markerValue.geoAccuracy, markerValue.beacon);

    const inActiveStats = () => {
        const assetTimestamp = markerValue.timestamp;
        const curretTimestamp = moment().format('YYYY-MM-DD HH:mm:ss');
        const diff = moment(curretTimestamp).diff(assetTimestamp, 'days');
        // this to check if asset timestamp are more than 7 days
        if (diff > 7) {
            return true;
        }
        return false;
    };

    const btnRefreshData = async (e) => {
        e.preventDefault();
        try {
            const reducer = { deviceIMEI: markerValue.deviceSerial };
            const result = await APISendTeltonikaCommand(reducer, token, agencyId, setApiLoading);
            if (result === 429) {
                // eslint-disable-next-line no-console
                console.log('too many request, please try again later');
                // setErrOpen(true);
                // setErrMsg("Too many requests. Please try again later");
                // setErrSevere("error");
            } else if (result.data.status === 200) {
                // eslint-disable-next-line no-console
                console.log('Command sent successfully');
                // setErrOpen(true);
                // setErrMsg("Command sent successfully");
                // setErrSevere("success");
            } else {
                // eslint-disable-next-line no-console
                console.log('something went wrong please try again later');
                // setErrOpen(true);
                // setErrMsg("Something went wrong. Please try again later");
                // setErrSevere("error");
            }
        } catch (err) {
            // eslint-disable-next-line no-console
            console.log('something went wrong please try again later');
            // setErrOpen(true);
            // setErrMsg("Something went wrong. Please try again later");
            // setErrSevere("error");
        }
    };

    const insightsNavigate = (params) => {
        const uuid = params.deviceOid;
        navigate('/insights/assetPerformance', { replace: true, state: { uuid } });
    };

    const telemetryNavigate = (params) => {
        const uuid = params.deviceOid;
        navigate('/live/telemetrySnapshot', { replace: true, state: { uuid } });
    };

    // Correct the function definition to accept two parameters

    const renderCardDetails = () => {
        if (markerValue.assetType === 'EV1') {
            return (
                <div className="asset-card-content-container">
                    <div className="asset-card-geolocation-container">
                        <div className="asset-card-info-detail">
                            <img loading="lazy" src={BatteryIcon} alt="gpsFixIcon" />
                            <div className="asset-card-address-text">
                                <div className="asset-card-detail-text">
                                    {/* Display the percentage and the icon beside it */}
                                    {getBatteryState(markerValue.dcVolt, devicePreferences?.batteryMappingPreference).percentage !== null
                                        ? `${getBatteryState(markerValue.dcVolt, devicePreferences?.batteryMappingPreference).percentage} %`
                                        : '-'}
                                    {getBatteryState(markerValue.dcVolt, devicePreferences?.batteryMappingPreference).icon && (
                                        <img
                                          loading="lazy"
                                          src={getBatteryState(markerValue.dcVolt, devicePreferences?.batteryMappingPreference).icon}
                                          alt="battery-state"
                                        />
                                    )}
                                    {markerValue.dcVolt > 84.1 && <img loading="lazy" src={OverChargeIcon} alt="overcharged" />}
                                </div>
                                <div className="asset-device-detail-container">
                                    {markerValue.dcVolt ? ` ${markerValue.dcVolt.toFixed(2)} V` : '-'}
                                </div>
                            </div>
                        </div>
                        <div className="asset-card-info-detail">
                            <img loading="lazy" src={SignalIcon} alt="pointer-icon" />
                            <div className="asset-card-address-text">
                                <div className="asset-card-signal-container">
                                    <div className="asset-card-detail-text">{markerValue.operatorName ? markerValue.operatorName : '-'}</div>
                                    {signalIcon(markerValue.signalQuality)}
                                </div>
                                <div className="asset-device-detail-container">{signalText(markerValue.signalQuality)}</div>
                            </div>
                        </div>
                    </div>
                    {/* Ev vehicle data */}
                    <div className="asset-card-geolocation-container">
                        <div className="asset-card-info-detail">
                            <img loading="lazy" src={EvCharge} alt="evchargeIcon" />
                            <div className="asset-card-address-text">
                                <div className="asset-card-detail-text">
                                    {/* Display the percentage and the icon beside it */}
                                    {getEvBatteryState(markerValue.cachedData.obd.oemBatteryChargeLevel, devicePreferences?.starterBatteryConfigId).percentage !== null
                                        ? `${getEvBatteryState(markerValue.cachedData.obd.oemBatteryChargeLevel, devicePreferences?.starterBatteryConfigId).percentage} %`
                                        : '-'}
                                    {getEvBatteryState(markerValue.cachedData.obd.oemBatteryChargeLevel, devicePreferences?.starterBatteryConfigId).icon && (
                                        <img
                                          loading="lazy"
                                          src={getEvBatteryState(markerValue.cachedData.obd.oemBatteryChargeLevel, devicePreferences?.starterBatteryConfigId).icon}
                                          alt="battery-state"
                                        />
                                    )}
                                </div>
                                <div className="asset-device-detail-container">
                                    <div
                                      className="geo-detail"
                                      onMouseEnter={() => setHovered(true)}
                                      onMouseLeave={() => setHovered(false)}
                                    >
                                    {markerValue.charging === true
                                        ? 'Charging'
                                        : getEvBatteryState(markerValue.cachedData.obd.oemBatteryChargeLevel, devicePreferences?.starterBatteryConfigId).state
                                    }
                                    {hovered && description && (
                                        <div className="geo-description">
                                            {/* {description} */}
                                            {markerValue.batterySoH ? `State of health ${markerValue.batterySoH}%` : 'State of health -'}
                                        </div>
                                    )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="asset-card-info-detail">
                            <img loading="lazy" src={EvTemp} alt="evTempIcon" />
                            <div className="asset-card-address-text">
                                <div className="asset-card-signal-container">
                                    <div className="asset-card-detail-text">
                                        {batteryTemp !== null && !Number.isNaN(Number(batteryTemp))
                                            ? `${parseInt(batteryTemp, 10).toLocaleString()} °C`
                                            : '-'}
                                    </div>
                                </div>
                                <div className="asset-device-detail-container">Battery Temperature</div>
                            </div>
                        </div>
                    </div>
                    <div className="asset-card-geolocation-container">
                        {/* Ev Distance Left Indicator */}
                        <div className="asset-card-info-detail">
                            <img loading="lazy" src={EvDistance} alt="evDistanceIcon" />
                            <div className="asset-card-address-text">
                                <div className="asset-card-detail-text">
                                        {rangeRemain !== null && !Number.isNaN(Number(rangeRemain))
                                            ? `${parseInt(rangeRemain, 10).toLocaleString()} KM`
                                            : '-'}
                                </div>
                                <div className="asset-device-detail-container">
                                    Distance Left
                                </div>
                            </div>
                        </div>
                        {/* Total Mileage Indicator */}
                        <div className="asset-card-info-detail">
                            <img loading="lazy" src={MileageIcon} alt="pointer-icon" />
                            <div className="asset-card-address-text">
                                <div className="asset-card-signal-container">
                                    <div className="asset-card-detail-text">
                                        {mileage !== null && !Number.isNaN(Number(mileage))
                                            ? `${parseInt(mileage, 10).toLocaleString()} KM`
                                            : '-'}
                                    </div>
                                </div>
                                <div className="asset-device-detail-container">Total Mileage</div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        } if (markerValue.assetType === 'EV2') {
            return (
                <div className="asset-card-content-container">
                    <div className="asset-card-geolocation-container">
                        <div className="asset-card-info-detail">
                            <img loading="lazy" src={BatteryIcon} alt="gpsFixIcon" />
                            <div className="asset-card-address-text">
                                <div className="asset-card-detail-text">
                                    {/* Display the percentage and the icon beside it */}
                                    {getBatteryState(markerValue.dcVolt, devicePreferences?.batteryMappingPreference).percentage !== null
                                        ? `${getBatteryState(markerValue.dcVolt, devicePreferences?.batteryMappingPreference).percentage} %`
                                        : '-'}
                                    {getBatteryState(markerValue.dcVolt, devicePreferences?.batteryMappingPreference).icon && (
                                        <img
                                          loading="lazy"
                                          src={getBatteryState(markerValue.dcVolt, devicePreferences?.batteryMappingPreference).icon}
                                          alt="battery-state"
                                        />
                                    )}
                                    {markerValue.dcVolt > 84.1 && <img loading="lazy" src={OverChargeIcon} alt="overcharged" />}
                                </div>
                                <div className="asset-device-detail-container">
                                    {markerValue.dcVolt ? ` ${markerValue.dcVolt.toFixed(2)} V` : '-'}
                                </div>
                            </div>
                        </div>
                        <div className="asset-card-info-detail">
                            <img loading="lazy" src={SignalIcon} alt="pointer-icon" />
                            <div className="asset-card-address-text">
                                <div className="asset-card-signal-container">
                                    <div className="asset-card-detail-text">{markerValue.operatorName ? markerValue.operatorName : '-'}</div>
                                    {signalIcon(markerValue.signalQuality)}
                                </div>
                                <div className="asset-device-detail-container">{signalText(markerValue.signalQuality)}</div>
                            </div>
                        </div>
                    </div>
                    {/* Ev vehicle battery 1 */}
                    <div className="asset-card-geolocation-container">
                        <div className="asset-card-info-detail">
                            <img loading="lazy" src={EvCharge} alt="evchargeIcon" />
                            <div className="asset-card-address-text">
                                <div className="asset-card-detail-text">
                                    {/* Display the percentage and the icon beside it */}
                                    {getEvBatteryState(markerValue.battery1Percentage, devicePreferences?.batteryOneConfigId).percentage !== null
                                        ? `${getEvBatteryState(markerValue.battery1Percentage, devicePreferences?.batteryOneConfigId).percentage} %`
                                        : '-'}
                                    {getEvBatteryState(markerValue.battery1Percentage, devicePreferences?.batteryOneConfigId).icon && (
                                        <img
                                          loading="lazy"
                                          src={getEvBatteryState(markerValue.battery1Percentage, devicePreferences?.batteryOneConfigId).icon}
                                          alt="battery-state"
                                        />
                                    )}
                                </div>
                                <div className="asset-device-detail-container">
                                    <div
                                      className="geo-detail"
                                      onMouseEnter={() => setHovered(true)}
                                      onMouseLeave={() => setHovered(false)}
                                    >
                                    {markerValue.charging === true
                                        ? 'Charging'
                                        : getEvBatteryState(markerValue.battery1Percentage, devicePreferences?.batteryOneConfigId).state
                                    }
                                    {hovered && description && (
                                        <div className="geo-description">
                                            {/* {description} */}
                                            {markerValue.batterySoH ? `State of health ${markerValue.batterySoH}%` : 'State of health -'}
                                        </div>
                                    )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* Ev vehicle battery 2 */}
                        <div className="asset-card-info-detail">
                            <img loading="lazy" src={EvCharge} alt="evchargeIcon" />
                            <div className="asset-card-address-text">
                                <div className="asset-card-detail-text">
                                    {/* Display the percentage and the icon beside it */}
                                    {getEvBatteryState(markerValue.battery2Percentage, devicePreferences?.batteryTwoConfigId).percentage !== null
                                        ? `${getEvBatteryState(markerValue.battery2Percentage, devicePreferences?.batteryTwoConfigId).percentage} %`
                                        : '-'}
                                    {getEvBatteryState(markerValue.battery2Percentage, devicePreferences?.batteryTwoConfigId).icon && (
                                        <img
                                          loading="lazy"
                                          src={getEvBatteryState(markerValue.battery2Percentage, devicePreferences?.batteryTwoConfigId).icon}
                                          alt="battery-state"
                                        />
                                    )}
                                </div>
                                <div className="asset-device-detail-container">
                                    <div
                                      className="geo-detail"
                                      onMouseEnter={() => setHovered(true)}
                                      onMouseLeave={() => setHovered(false)}
                                    >
                                    {markerValue.charging === true
                                        ? 'Charging'
                                        : getEvBatteryState(markerValue.battery2Percentage, devicePreferences?.batteryTwoConfigId).state
                                    }
                                    {hovered && description && (
                                        <div className="geo-description">
                                            {/* {description} */}
                                            {markerValue.batterySoH ? `State of health ${markerValue.batterySoH}%` : 'State of health -'}
                                        </div>
                                    )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="asset-card-geolocation-container">
                        {/* Ev Distance Left Indicator */}
                        <div className="asset-card-info-detail">
                            <img loading="lazy" src={EvDistance} alt="evDistanceIcon" />
                            <div className="asset-card-address-text">
                                <div className="asset-card-detail-text">
                                    {rangeRemain !== null && !Number.isNaN(Number(rangeRemain))
                                        ? `${parseInt(rangeRemain, 10).toLocaleString()} KM`
                                        : '-'}
                                </div>
                                <div className="asset-device-detail-container">
                                    Distance Left

                                </div>
                            </div>
                        </div>
                        {/* Total Mileage Indicator */}
                        <div className="asset-card-info-detail">
                            <img loading="lazy" src={MileageIcon} alt="pointer-icon" />
                            <div className="asset-card-address-text">
                                <div className="asset-card-signal-container">
                                    <div className="asset-card-detail-text">
                                        {mileage !== null && !Number.isNaN(Number(mileage))
                                            ? `${parseInt(mileage, 10).toLocaleString()} KM`
                                            : '-'}
                                    </div>
                                </div>
                                <div className="asset-device-detail-container">Total Mileage</div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        } if (markerValue.assetType === 'Hybrid') {
            return (
                <div className="asset-card-content-container">
                    <div className="asset-card-geolocation-container">
                        <div className="asset-card-info-detail">
                            <img loading="lazy" src={BatteryIcon} alt="gpsFixIcon" />
                            <div className="asset-card-address-text">
                                <div className="asset-card-detail-text">
                                    {/* Display the percentage and the icon beside it */}
                                    {getBatteryState(markerValue.dcVolt, devicePreferences?.batteryMappingPreference).percentage !== null
                                        ? `${getBatteryState(markerValue.dcVolt, devicePreferences?.batteryMappingPreference).percentage} %`
                                        : '-'}
                                    {getBatteryState(markerValue.dcVolt, devicePreferences?.batteryMappingPreference).icon && (
                                        <img
                                          loading="lazy"
                                          src={getBatteryState(markerValue.dcVolt, devicePreferences?.batteryMappingPreference).icon}
                                          alt="battery-state"
                                        />
                                    )}
                                    {markerValue.dcVolt > 84.1 && <img loading="lazy" src={OverChargeIcon} alt="overcharged" />}
                                </div>
                                <div className="asset-device-detail-container">
                                    {markerValue.dcVolt ? ` ${markerValue.dcVolt.toFixed(2)} V` : '-'}
                                </div>
                            </div>
                        </div>
                        <div className="asset-card-info-detail">
                            <img loading="lazy" src={SignalIcon} alt="pointer-icon" />
                            <div className="asset-card-address-text">
                                <div className="asset-card-signal-container">
                                    <div className="asset-card-detail-text">{markerValue.operatorName ? markerValue.operatorName : '-'}</div>
                                    {signalIcon(markerValue.signalQuality)}
                                </div>
                                <div className="asset-device-detail-container">{signalText(markerValue.signalQuality)}</div>
                            </div>
                        </div>
                    </div>
                    {/* Ev vehicle data */}
                    <div className="asset-card-geolocation-container">
                        <div className="asset-card-info-detail">
                            <img loading="lazy" src={EvCharge} alt="evchargeIcon" />
                            <div className="asset-card-address-text">
                                <div className="asset-card-detail-text">
                                    {/* Display the percentage and the icon beside it */}
                                    {getEvBatteryState(markerValue.cachedData.obd.oemBatteryChargeLevel, devicePreferences?.starterBatteryConfigId).percentage !== null
                                        ? `${getEvBatteryState(markerValue.cachedData.obd.oemBatteryChargeLevel, devicePreferences?.starterBatteryConfigId).percentage} %`
                                        : '-'}
                                    {getEvBatteryState(markerValue.cachedData.obd.oemBatteryChargeLevel, devicePreferences?.starterBatteryConfigId).icon && (
                                        <img
                                          loading="lazy"
                                          src={getEvBatteryState(markerValue.cachedData.obd.oemBatteryChargeLevel, devicePreferences?.starterBatteryConfigId).icon}
                                          alt="battery-state"
                                        />
                                    )}
                                </div>
                                <div className="asset-device-detail-container">
                                    <div
                                      className="geo-detail"
                                      onMouseEnter={() => setHovered(true)}
                                      onMouseLeave={() => setHovered(false)}
                                    >
                                    {markerValue.charging === true
                                        ? 'Charging'
                                        : getEvBatteryState(markerValue.cachedData.obd.oemBatteryChargeLevel, devicePreferences?.starterBatteryConfigId).state
                                    }
                                    {hovered && description && (
                                        <div className="geo-description">
                                            {/* {description} */}
                                            {markerValue.batterySoH ? `State of health ${markerValue.batterySoH}%` : 'State of health -'}
                                        </div>
                                    )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="asset-card-info-detail">
                            <img loading="lazy" src={EvTemp} alt="evTempIcon" />
                            <div className="asset-card-address-text">
                                <div className="asset-card-signal-container">
                                    <div className="asset-card-detail-text">
                                        {batteryTemp !== null && !Number.isNaN(Number(batteryTemp))
                                            ? `${parseInt(batteryTemp, 10).toLocaleString()} °C`
                                            : '-'}
                                    </div>
                                </div>
                                <div className="asset-device-detail-container">Battery Temperature</div>
                            </div>
                        </div>
                    </div>
                    <div className="asset-card-geolocation-container">
                        {/* Fuel Level Indicator */}
                        <div className="asset-card-info-detail">
                            <img loading="lazy" src={GasStationIcon} alt="gpsFixIcon" />
                            <div className="asset-card-address-text">
                                <div className="asset-card-detail-text">
                                    {computedFuelLevelPerc !== null
                                        ? `${computedFuelLevelPerc.toFixed(0)} %`
                                        : '-'}
                                    <FuelStateBadge state={fuelStateBadge} />
                                </div>
                                <div className="asset-device-detail-container">
                                    {computedFuelLevelLitre !== null
                                        ? `${computedFuelLevelLitre.toFixed(2)} litres`
                                        : '-'}
                                </div>
                            </div>
                        </div>
                        {/* Ev Distance Left Indicator */}
                        <div className="asset-card-info-detail">
                            <img loading="lazy" src={EvDistance} alt="evDistanceIcon" />
                            <div className="asset-card-address-text">
                                <div className="asset-card-detail-text">
                                    {rangeRemain !== null && !Number.isNaN(Number(rangeRemain))
                                        ? `${parseInt(rangeRemain, 10).toLocaleString()} KM`
                                        : '-'}
                                </div>
                                <div className="asset-device-detail-container">
                                    Distance Left
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="asset-card-geolocation-container">
                        {/* Total Mileage Indicator */}
                        <div className="asset-card-info-detail">
                            <img loading="lazy" src={MileageIcon} alt="pointer-icon" />
                            <div className="asset-card-address-text">
                                <div className="asset-card-signal-container">
                                    <div className="asset-card-detail-text">
                                        {mileage !== null && !Number.isNaN(Number(mileage))
                                            ? `${parseInt(mileage, 10).toLocaleString()} KM`
                                            : '-'}
                                    </div>
                                </div>
                                <div className="asset-device-detail-container">Total Mileage</div>
                            </div>
                        </div>
                    </div>
                    {/* <div className="asset-card-address-container">
                <img src={AssetUtiliseIcon} alt="address-icon" />
                <div className="asset-card-address-text">
                    <div className="asset-card-detail-text">-</div>
                    <div className="asset-device-detail-container">Average Utilisation Rate</div>
                </div>
            </div> */}
                </div>
            );
        }
        return (
            <div className="asset-card-content-container">
                <div className="asset-card-geolocation-container">
                    <div className="asset-card-info-detail">
                        <img loading="lazy" src={BatteryIcon} alt="gpsFixIcon" />
                        <div className="asset-card-address-text">
                            <div className="asset-card-detail-text">
                                {/* Display the percentage and the icon beside it */}
                                {getBatteryState(markerValue.dcVolt, devicePreferences?.batteryMappingPreference).percentage !== null
                                    ? `${getBatteryState(markerValue.dcVolt, devicePreferences?.batteryMappingPreference).percentage} %`
                                    : '-'}
                                {getBatteryState(markerValue.dcVolt, devicePreferences?.batteryMappingPreference).icon && (
                                    <img
                                      loading="lazy"
                                      src={getBatteryState(markerValue.dcVolt, devicePreferences?.batteryMappingPreference).icon}
                                      alt="battery-state"
                                    />
                                )}
                                {markerValue.dcVolt > 84.1 && <img loading="lazy" src={OverChargeIcon} alt="overcharged" />}
                            </div>
                            <div className="asset-device-detail-container">
                                {markerValue.dcVolt ? ` ${markerValue.dcVolt.toFixed(2)} V` : '-'}
                            </div>
                        </div>
                    </div>
                    <div className="asset-card-info-detail">
                        <img loading="lazy" src={SignalIcon} alt="pointer-icon" />
                        <div className="asset-card-address-text">
                            <div className="asset-card-signal-container">
                                <div className="asset-card-detail-text">{markerValue.operatorName ? markerValue.operatorName : '-'}</div>
                                {signalIcon(markerValue.signalQuality)}
                            </div>
                            <div className="asset-device-detail-container">{signalText(markerValue.signalQuality)}</div>
                        </div>
                    </div>
                </div>
                <div className="asset-card-geolocation-container">
                    {/* Fuel Level Indicator */}
                    <div className="asset-card-info-detail">
                        <img loading="lazy" src={GasStationIcon} alt="gpsFixIcon" />
                        <div className="asset-card-address-text">
                            <div className="asset-card-detail-text">
                                {computedFuelLevelPerc !== null
                                    ? `${computedFuelLevelPerc.toFixed(0)} %`
                                    : '-'}
                                <FuelStateBadge state={fuelStateBadge} />
                            </div>
                            <div className="asset-device-detail-container">
                                {computedFuelLevelLitre !== null
                                    ? `${computedFuelLevelLitre.toFixed(2)} litres`
                                    : '-'}
                            </div>
                        </div>
                    </div>
                    {/* Total Mileage Indicator */}
                    <div className="asset-card-info-detail">
                        <img loading="lazy" src={MileageIcon} alt="pointer-icon" />
                        <div className="asset-card-address-text">
                            <div className="asset-card-signal-container">
                                <div className="asset-card-detail-text">
                                    {mileage !== null && !Number.isNaN(Number(mileage))
                                        ? `${parseInt(mileage, 10).toLocaleString()} KM`
                                        : '-'}
                                </div>
                            </div>
                            <div className="asset-device-detail-container">Total Mileage</div>
                        </div>
                    </div>
                </div>
                {/* <div className="asset-card-address-container">
                <img src={AssetUtiliseIcon} alt="address-icon" />
                <div className="asset-card-address-text">
                    <div className="asset-card-detail-text">-</div>
                    <div className="asset-device-detail-container">Average Utilisation Rate</div>
                </div>
            </div> */}
            </div>
        );
    };

    const renderScanSummary = () => {
        const bleSpan = markerValue?.bleSpan;
        if (!bleSpan) return null;
        return (
            <div className="asset-card-content-container">
                <ScanSummaryCard bleSpan={bleSpan} />
            </div>
        );
    };

    return (
        <div className={isMobileOrTablet ? 'asset-card-detail-container-mobile' : 'asset-card-detail-container'}>
            <div className="asset-card-header-container">
                <div className="asset-card-device-container">
                    {/* <img loading="lazy" src={TruckAssetIcon} alt="truck-icon" /> */}
                    <EvIcon assetType={markerValue.assetType} />
                    <ToolTips text={markerValue.assetName} disbledHover={!hover}>
                        <div ref={textElementRef} className="asset-card-header-text">{markerValue.assetName ? markerValue.assetName : '-'}</div>
                    </ToolTips>
                    <MotionState motionInference={markerValue.motionInference} />
                    <EvIndicator assetType={markerValue.assetType} />
                    <img loading="lazy" src={CloseButtonIcon} alt="close-button" style={{ cursor: 'pointer' }} className="asset-card-close-button" onClick={(e) => closeButton(e)} />
                </div>
                <div className="asset-device-detail-container">{markerValue.deviceSerial ? `Device ${markerValue.deviceSerial}` : '-'}</div>
                <div className="asset-card-time-container ">
                    <img loading="lazy" src={TimeIcon} alt="time-icon" />
                    <div className="asset-card-detail-text">{markerValue.timestamp ? `Last updated ${timeStampDisplay}` : 'No Recent Activity'}</div>
                    {inActiveStats() && <img loading="lazy" src={InactiveIcon} alt="inactive" />}
                </div>
            </div>
            <div className="asset-card-content-container">
                <div className="asset-card-address-container">
                    <img loading="lazy" src={AddressIcon} alt="address-icon" />
                    <div className="asset-card-address-text">
                        {
                            displayLastSeen && (
                                <div className="asset-card-last-seen-container">
                                    <img loading="lazy" src={OrangeClockRewind} alt="orange-clock-rewind" />
                                    <div className="asset-card-last-seen-text">{`Last seen ${lastSeenTimestamp}`}</div>
                                </div>
                            )
                        }
                        <div className="asset-card-detail-text">{markerValue.address ? markerValue.address.localDisplay : '-'}</div>
                        <a className="asset-card-lat-lon-text" href={`https://www.google.com/maps/search/?api=1&query=${markerValue.latitude}, ${markerValue.longitude}`} rel="noopener noreferrer" target="_blank">{markerValue.latitude || markerValue.longitude ? `${markerValue.latitude}, ${markerValue.longitude}` : '-'}</a>
                    </div>
                </div>
                <div className="asset-card-geolocation-container">
                    <div className="asset-card-info-detail">
                        {geolocationStatusImg(markerValue.geolocationStatus, markerValue.beacon)}
                        {/* Commented out previous satellite code sections */}
                        {/* <div className="asset-card-address-text">
                        <div className="asset-card-detail-text">{geoLocationStatusText(markerValue.geolocationStatus, markerValue.beacon)}</div>
                        <div className="asset-device-detail-container">{geoLocationDetailText(markerValue.geolocationStatus, markerValue.nSat, markerValue.geoAccuracy, markerValue.beacon)}</div>
                    </div> */}
                        <div className="asset-card-address-text">
                            <div className="asset-card-detail-text">
                                {geoLocationStatusText(markerValue.geolocationStatus, markerValue.beacon)}
                            </div>
                            <div className="asset-device-detail-container">
                                <div
                                  className="geo-detail"
                                  onMouseEnter={() => setHovered(true)}
                                  onMouseLeave={() => setHovered(false)}
                                >
                                    {text}
                                    {/* Tooltip */}
                                    {hovered && description && (
                                        <div className="geo-description">
                                            {description}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="asset-card-address-container">
                        <img loading="lazy" src={SpeedometerIcon} alt="address-icon" />
                        <div className="asset-card-address-text-main">
                            <div className="asset-card-detail-text">{markerValue.kmh ? `${markerValue.kmh.toFixed(2)} km/h` : '-'}</div>
                            {markerValue.kmh > 101 && <img loading="lazy" src={OverspeedIcon} alt="overspeed" />}
                            {/* <img src={OverspeedIcon} alt="overspeed" /> */}
                        </div>
                    </div>
                    {/* <div className="asset-card-info-detail">
                    <img src={PointerIcon} alt="pointer-icon" />
                    <div className="asset-card-address-text">
                        <div className="asset-card-detail-text">-</div>
                        <div className="asset-device-detail-container">Recorded Distance</div>
                    </div>
                </div> */}
                </div>
            </div>
            {renderCardDetails()}
            {renderScanSummary()}
            <div className="immobilizer-container">
                {/* Keep original behavior commented for quick re-enable later:
                    className={`immobilizer-button ${immobilized ? 'immobilizer-button-active' : 'immobilizer-button-inactive'}`}
                    onClick={() => setImmobilized(!immobilized)}
                */}
                <button
                  type="button"
                  className="immobilizer-button immobilizer-button-inactive immobilizer-button-disabled"
                  disabled
                >
                    {immobilized ? (
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                            <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                        </svg>
                    ) : (
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                            <path d="M7 11V7a5 5 0 0 1 9.9-1" />
                        </svg>
                    )}
                    {immobilized ? 'Immobilized — Click to Restore' : 'Immobilize'}
                </button>
            </div>
            <div className="asset-card-buttons-container">
                {/* <LatestDataButton label="Refresh Data" refreshClick={btnRefreshData} disable /> */}
                <AssetCardButton indicator="telemetry" navigateButton={() => telemetryNavigate(markerValue)} />
                <AssetCardButton indicator="assetStatus" navigateButton={() => insightsNavigate(markerValue)} />
                <AssetCardButton indicator="truck" navigateButton={() => fetchDevice(markerValue)} />
            </div>
        </div>
    );
}
